import React, { Component } from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import Routes from '../routes/index';

class App extends Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <Provider store={this.props.store}>
        <Routes />
      </Provider>
    );
  }
}

export default App;
